module.exports = __webpack_public_path__ + "static/media/tesstea.c4f90195.png";